export default [
    {label: 'Desativar', value: 0},
    {label: 'Permitir e obrigatório', value: 1},
    {label: 'Permitir, mas não obrigatório', value: 2},
    {label: 'Obrigatório e com análise', value: 3},
    {label: 'Somente homologados TRT', value: 4},
    {label: 'Obrigatório + Contrato', value: 5}
]
